import { createSelector } from 'reselect';
import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { HTTP_GONE, HTTP_UNAUTHORIZED } from '@/_shared/constants/httpStatusCode';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericGet } from '@/_shared/types';
import { GenericApiError } from '@/_shared/types/apiError';
import { API_CHECK_CONFIRM_TOKEN_PATH_KEY } from '@/swagger/constants/slash-keys';
import { API_GET_CONFIRM_TOKEN, KEY_GET_CONFIRM_TOKEN } from '../constants';
import { MOCK_RESPONSE_GET_CONFIRM_TOKEN } from '../mocks';

type RequestGetConfirmToken = GenericGet<
  typeof API_CHECK_CONFIRM_TOKEN_PATH_KEY
>['request']['query'];

type CallResponseGetConfirmToken = GenericGet<
  typeof API_CHECK_CONFIRM_TOKEN_PATH_KEY
>['response']['body'];

export type CallParamsGetConfirmToken = RequestGetConfirmToken & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

type CallErrorGetConfirmToken = GenericApiError;

type CallSelectorsGetConfirmToken = {
  organizationId: string | undefined;
  isTokenExpired: boolean;
};

export const getConfirmTokenCall = createGeneralCall<
  CallParamsGetConfirmToken,
  CallResponseGetConfirmToken,
  CallErrorGetConfirmToken,
  CallSelectorsGetConfirmToken
>({
  id: KEY_GET_CONFIRM_TOKEN,
  url:
    ({ payload }) =>
    () =>
      API_GET_CONFIRM_TOKEN(payload),
  method: 'get',
  paramsSelector:
    ({ payload }) =>
    () =>
      payload,
  cancellable: true,
  successMock: IS_MOCK_ENABLED() ? MOCK_RESPONSE_GET_CONFIRM_TOKEN : undefined,
  selectors: {
    organizationId: ({ selectors }) =>
      createSelector(selectors.response, res => res?.organizationId),
    isTokenExpired: ({ selectors }) =>
      createSelector(
        selectors.error,
        error => error?.status === HTTP_UNAUTHORIZED || error?.status === HTTP_GONE,
      ),
  },
});
